import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Input,
  Spinner,
} from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';

interface TagCreateEditDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (tagName: string) => void;
  mode: 'create' | 'edit';
  initialValue?: string;
}

const TagCreateEditDialog: React.FC<TagCreateEditDialogProps> = ({
  isOpen,
  onClose,
  onSave,
  mode,
  initialValue = '',
}) => {
  const [tagName, setTagName] = useState(initialValue);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setTagName(initialValue);
  }, [initialValue, isOpen]);

  const handleSave = () => {
    if (tagName.trim()) {
      onSave(tagName.trim());
      setLoading(true);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      onClose();
    }
  };

  return (
    <Dialog modalType='alert' open={isOpen} onOpenChange={(_, data) => !data.open && onClose()}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            action={
              <Button
                appearance="subtle"
                icon={<DismissRegular />}
                onClick={onClose}
              />
            }
          >
            {mode === 'create' ? 'Skapa etikett' : 'Redigera etikett'}
          </DialogTitle>
          <DialogContent>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-2">
                  {mode === 'create' ? 'Skriv nya etikettens namn:' : 'Ändra etiketten namn:'}
                </label>
                <Input
                  className="w-full"
                  value={tagName}
                  onChange={(e) => setTagName(e.target.value)}
                  onKeyDown={handleKeyDown}
                  autoFocus
                />
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={onClose}>
              Avbryt
            </Button>
            <Button appearance="primary" onClick={handleSave} disabled={!tagName.trim() || loading}>
              {mode === 'create' ? 'Skapa' : 'Spara'}
            </Button>
            {loading && <Spinner />}
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default TagCreateEditDialog;
